import { render, staticRenderFns } from "./RelatorioInadimplencia.vue?vue&type=template&id=2bb523e7&scoped=true"
import script from "./RelatorioInadimplencia.vue?vue&type=script&lang=js"
export * from "./RelatorioInadimplencia.vue?vue&type=script&lang=js"
import style0 from "./RelatorioInadimplencia.vue?vue&type=style&index=0&id=2bb523e7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb523e7",
  null
  
)

export default component.exports